import React from 'react';
import Chip from 'material-ui/Chip';
import * as colors from 'material-ui/styles/colors';
import get from 'lodash/get';

const styles = {
  chip: {},
  wrapper: {
    display: 'flex',
    flexFlow: 'row wrap',
  },
};

const colorTable = {
  SE: { backgroundColor: colors.blue500, labelColor: colors.yellow400 },
  DK: { backgroundColor: colors.grey100, labelColor: colors.red600 },
  FI: { backgroundColor: colors.grey100, labelColor: colors.blue800 },
  NO: { backgroundColor: colors.red600, labelColor: colors.blue100 },
  EN: { backgroundColor: colors.blue800, labelColor: colors.red300 },
};

export const ChipRender = (record, boolKey) => (
  <div style={styles.wrapper}>
    {record.markets && record.markets.length > 0 && record.markets.filter(boolKey ? (market) => get(market, boolKey) : () => true).map((market) => (
      <Chip
        {...colorTable[market.countryCode]}
        style={styles.chip}
      >{market.countryCode}
      </Chip>
    ))}
    {record.venues && record.venues.length > 0 && record.venues.map((venue) => (
      <Chip
        {...colorTable[venue.market]}
        style={styles.chip}
      >{venue.name}
      </Chip>
    ))}
  </div>
);
